export const licensing = {
};